import ProtectedMenuItemLink from "../ProtectedMenuItemLink";
import SubMenu from "../SubMenu";
import React, { FC } from "react";
import DescriptionIcon from "@material-ui/icons/Description";
import subcontractor from "../../../pages/subcontractors";
import subcontractorTimesheets from "../../../pages/subcontractorTimesheets";
import { useSelector } from "react-redux";
import { AppState } from "../Menu";
import SectionComponent from "../SectionComponent";

interface SubcontractorsMenuProps {
  permissions: string[];
}

const SubcontractorsMenu: FC<SubcontractorsMenuProps> = ({ permissions }) => {
  const open = useSelector((state: AppState) => state.admin.ui.sidebarOpen);

  const availableResources = [
    "subcontractors",
    "subcontractorTimesheets",
    "subcontractorAdhocFees",
    "subcontractorErps",
    "subcontractorRouteTransactions",
    "subcontractorPurchaseInvoices",
    "subcontractorAdjustmentPrices",
  ];

  if (permissions.length === 0) {
    return <></>;
  }

  // Give specific show menu access based on resource
  const findResources = permissions.filter((permission) =>
    availableResources.includes(permission),
  );
  if (findResources.length === 0) {
    return <></>;
  }

  return (
    <SectionComponent name={open ? "Subcontractors" : "S"}>
      <ProtectedMenuItemLink
        to={`/subcontractors`}
        primaryText={"Subcontractors"}
        leftIcon={<subcontractor.icon />}
        permissions={permissions}
        permissionResource="subcontractors"
      />
      <ProtectedMenuItemLink
        to={`/subcontractorTimesheets`}
        primaryText={"Subcontractor Timesheets"}
        leftIcon={<subcontractorTimesheets.icon />}
        style={{ whiteSpace: "normal" }}
        permissions={permissions}
        permissionResource="subcontractorTimesheets"
      />
      <SubMenu
        name="Subcontractor Finance"
        icon={<DescriptionIcon />}
        permissions={permissions}
        permissionResources={[
          "subcontractorAdhocFees",
          "subcontractorRouteTransactions",
          "subcontractorPurchaseInvoices",
          "subcontractorErps",
          "subcontractorAdjustmentPrices",
        ]}
      >
        <ProtectedMenuItemLink
          to={`/subcontractorAdhocFees`}
          primaryText={"Subcontractor Adhoc Fees"}
          leftIcon={<DescriptionIcon />}
          style={{ whiteSpace: "normal" }}
          permissions={permissions}
          permissionResource="subcontractorAdhocFees"
        />
        <ProtectedMenuItemLink
          to={`/subcontractorErps`}
          primaryText={"Subcontractor ERP Charges"}
          leftIcon={<DescriptionIcon />}
          style={{ whiteSpace: "normal" }}
          permissions={permissions}
          permissionResource="subcontractorErps"
        />
        <ProtectedMenuItemLink
          to={`/subcontractorAdjustmentPrices`}
          primaryText={"Subcontractor Adjustment Prices"}
          leftIcon={<DescriptionIcon />}
          style={{ whiteSpace: "normal" }}
          permissions={permissions}
          permissionResource="subcontractorAdjustmentPrices"
        />
        <ProtectedMenuItemLink
          to={`/subcontractorRouteTransactions`}
          primaryText={"Subcontractor Route Transactions"}
          leftIcon={<DescriptionIcon />}
          style={{ whiteSpace: "normal" }}
          permissions={permissions}
          permissionResource="subcontractorRouteTransactions"
        />
        <ProtectedMenuItemLink
          to={`/subcontractorPurchaseInvoices`}
          primaryText={"Subcontractor Purchase Invoices"}
          leftIcon={<DescriptionIcon />}
          style={{ whiteSpace: "normal" }}
          permissions={permissions}
          permissionResource="subcontractorPurchaseInvoices"
        />
      </SubMenu>
    </SectionComponent>
  );
};

export default SubcontractorsMenu;
